import { generateTestId } from "@client-shared";

export const setBatchActionsTestId = (identifier: string): string =>
  generateTestId("BatchActions", identifier);
